import React, { createContext, useCallback, useContext, useMemo } from "react";
import { useToast } from "@npm-telluria-tecnologia/telluria-ui";

// Rest
import { api } from "@store/services/rest";

// Graphql
import { ArchiveType } from "@store/graphql/helpers/types.graphql";

interface DownloadArchiveContextData {
  downloadArchive: (archive: ArchiveType) => Promise<void>;
}

const DownloadArchiveContextData = createContext<DownloadArchiveContextData>(
  {} as DownloadArchiveContextData
);
const DownloadArchiveProvider: React.FC = ({ children }) => {
  const { addToast } = useToast();

  const downloadArchive = useCallback(
    async (archive: ArchiveType) => {
      try {
        const response = await api.get(
          `/customer/Archives/Download/${archive?.id}`,
          {
            responseType: "blob"
          }
        );

        const blob = new Blob([response.data], { type: archive?.extension });
        const archiveURL = window.URL.createObjectURL(blob);
        const tempLink = document.createElement("a");

        tempLink.href = archiveURL;
        tempLink.setAttribute("download", archive?.originalName || "");
        tempLink.click();
      } catch (error) {
        addToast({
          type: "error",
          title: "Internal client error",
          description: error.message
        });
      }
    },
    [addToast]
  );

  const provider = useMemo(
    () => ({
      downloadArchive
    }),
    [downloadArchive]
  );

  return (
    <DownloadArchiveContextData.Provider value={provider}>
      {children}
    </DownloadArchiveContextData.Provider>
  );
};

function useDownloadProvider(): DownloadArchiveContextData {
  const context = useContext(DownloadArchiveContextData);

  return context;
}

export { DownloadArchiveProvider, useDownloadProvider };
